import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormControl, FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { IApplication } from '../models/application.model';

import { ApplicationService } from '../Services/application.service';
import { HeaderService } from '../Services/header.service';
import { AppInitialsPipe } from '../shared/pipes/appInitials.pipe';

@Component({
  selector: 'app-entry',
  templateUrl: './app-entry.component.html',
  styleUrls: ['../app.component.scss'],
  providers: [AppInitialsPipe]
})
export class AppEntryComponent implements OnInit {
  isSet = false;
  // messageAction = 'updated';
  // publishToggle = 'Publish Release Notes';
  cancelledChange = false;
  // noteID: number;
  appList: IApplication[];
  appForm: FormGroup;
  formOriginal: any;
  primary: string;
  secondary: string;

  get ApplicationId() { return this.appForm.get('ApplicationId'); }
  get AppName() { return this.appForm.get('AppName'); }
  get IsActive() { return this.appForm.get('IsActive'); }
  get PrimaryColor() { return this.appForm.get('PrimaryColor'); }
  get SecondaryColor() { return this.appForm.get('SecondaryColor'); }
  get Initials() { return this.appForm.get('Initials'); }

  constructor(private applicationService: ApplicationService, private headerService: HeaderService,
              protected Sanitizer: DomSanitizer, private formBuilder: FormBuilder, private Inits: AppInitialsPipe) {
  }

  // @ViewChild('instance', {static: true}) instance: NgbTypeahead;
  // focus$ = new Subject<string>();
  // click$ = new Subject<string>();

  // search = (text$: Observable<string>) => {
  //   const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
  //   const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance.isPopupOpen()));
  //   const inputFocus$ = this.focus$;

  //   return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
  //     map(term => (term === '' ? this.nameArray
  //       : this.nameArray.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1)).slice(0, 10))
  //   );
  // }

  ngOnInit(): void {

    this.getAppList();
    this.appForm = this.formBuilder.group({
      ApplicationId: new FormControl('', Validators.required),
      AppName: new FormControl('', [Validators.required, Validators.maxLength(50), Validators.minLength(3)]),
      IsActive: new FormControl(true),
      PrimaryColor: new FormControl('', [Validators.required, Validators.maxLength(9), Validators.minLength(4),
      Validators.pattern(/^[#][a-fA-F0-9]{3,8}$/)]),
      SecondaryColor: new FormControl('', [Validators.required, Validators.maxLength(9), Validators.minLength(4),
      Validators.pattern(/^[#][a-fA-F0-9]{3,8}$/)]),
      Initials: new FormControl('', [Validators.required, Validators.maxLength(4), Validators.minLength(2)]),
    });
    this.headerService.checkAuth(true);
    this.headerService.setBreadcrumbs(null, null, null, true);
  }

  getAppList(callback = () => { }) {
    return this.applicationService.getAllApplications().subscribe(x => {
      this.appList = x;
    }, error => { console.log(error); }, callback);
  }

  updatePrimaryColor(event) {
    this.appForm.patchValue({ PrimaryColor: event });
  }

  updateSecondaryColor(event) {
    this.appForm.patchValue({ SecondaryColor: event });
  }

  onNameBlur(event) {
    const trimmedName = this.AppName.value.trim();
    if (!this.Initials.value) {
      this.appForm.patchValue({ AppName: trimmedName, Initials: this.Inits.transform(trimmedName) });
    }

    this.headerService.setBreadcrumbs(trimmedName, +this.ApplicationId.value, null, true);
  }

  onAppChange(event) {
    this.headerService.clearAlerts();

    if (!this.cancelledChange) {
      if (this.isOKForReset()) {
        this.setupFormForEntry();
      } else {
        this.cancelledChange = true;
        this.appForm.patchValue({
          ApplicationId: this.formOriginal.ApplicationId,
        });
      }
    }
    this.cancelledChange = false;
  }

  isOKForReset(): boolean {
    const currentApp = this.AppName.value + this.Initials.value + this.PrimaryColor.value +
      this.SecondaryColor.value + this.IsActive.value;

    if (this.formOriginal) {
      const originalApp = this.formOriginal.AppName + this.formOriginal.Initials +
        this.formOriginal.PrimaryColor + this.formOriginal.SecondaryColor + this.formOriginal.IsActive;

      if (currentApp !== originalApp) {
        return confirm('It appears that you have made changes to this entry - if you proceed, these will be lost');
      }
    }
    return true;
  }

  setupFormForEntry() {
    if (this.ApplicationId.valid) {
      this.isSet = true;
      this.setNewOrEdit();
    } else {
      this.isSet = false;
    }
  }

  setNewOrEdit() {
    const entry = this.ApplicationId.value;
    const existingApp = this.appList.find((app) => {
      return app.applicationId === entry;
    });

    if (existingApp) {
      this.setFormValues(existingApp.applicationId, existingApp.appName, existingApp.isActive, existingApp.primaryColor,
        existingApp.secondaryColor, existingApp.initials);
    } else {
      // this.setFormValues(entry, '', true, '#be1e2dff', '#662d90ff', null);
      this.setFormValues(entry, '', true, '#0e6ab8ff', '#0e6ab8ff', null);
    }
  }

  onSubmit() {
    if (this.isFormValid()) {
      if (this.ApplicationId.value >= 0) {
        this.patchExistingApp();
      } else {
        this.appForm.patchValue({ ApplicationId: 0 });
        this.postNewApp();
      }
    }
  }

  private setFormValues(appID, appName, isActive, primary, secondary, initials) {
    this.appForm.patchValue({
      ApplicationId: appID, AppName: appName, IsActive: isActive, PrimaryColor: primary,
      SecondaryColor: secondary, Initials: initials
    });
    this.headerService.setBreadcrumbs(appName, +appID, null, true);
    this.formOriginal = this.appForm.value;
  }

  isFormValid(): boolean {
    this.headerService.clearAlerts();

    if (this.appForm.invalid) {
      this.appForm.markAllAsTouched();
    }

    return !this.appForm.invalid;
  }

  postNewApp() {
    this.applicationService.setApplication(this.appForm.value).subscribe(response => {
      if (response.isSuccess) {
        this.pushAlert('success',
          `Successfully added Application ${response.data[0].appName}!`);
      } else {
        this.pushAlert('danger',
          `Something went wrong: ${response.message}!`);
      }

      this.appList.push(response.data[0]);
      this.appForm.patchValue({ ApplicationId: response.data[0].applicationId });
      this.setupFormForEntry();
    });
  }

  patchExistingApp() {
    this.applicationService.updateApplication(this.appForm.value).subscribe(response => {
      if (response.isSuccess) {
        this.pushAlert('success',
          `Successfully Updated ${response.data[0].appName}!`);
      } else {
        this.pushAlert('danger',
          `Something went wrong: ${response.message}!`);
      }

      this.appList = this.appList.map((app) => {
        if (app.applicationId === response.data[0].applicationId) {
          app = response.data[0];
        }
        return app;
      });

      this.setFormValues(this.ApplicationId.value, this.AppName.value, this.IsActive.value, this.PrimaryColor.value,
        this.SecondaryColor.value, this.Initials.value);

      this.headerService.setBreadcrumbs(this.AppName.value, +this.ApplicationId.value, null, true);
    });
  }



  pushAlert(typ: string, mes: string) {
    this.headerService.pushAlerts(typ, mes);
    window.scroll(0, 0);
  }
}


